import React from 'react';
import { Controller } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import * as Grouped from '../Atoms/Grouped';

const specColumns = [
  { name: 'rimWidth', title: '림폭' },
  { name: 'offset', title: '옵셋' },
  { name: 'holeCount', title: '홀수' },
  { name: 'pcd', title: 'PCD' },
  { name: 'hub', title: '허브' },
];

const wheelSpecRows = [
  { prefix: 'front', label: '프론트휠' },
  { prefix: 'rear', label: '리어휠' },
];

const fieldPath = (suffix) => `vehicleInformation.wheelInformation.${suffix}`;

const thClass =
  'text-center font-semibold p-2 border-1 border-300 white-space-nowrap';
const tdClass = 'p-2 border-1 border-300';
const categoryColClass = 'wheel-inspection-category-col';

const WheelBasicInfoPanel = ({
  control,
  getFormErrorMessage,
  readOnly = false,
}) => {
  return (
    <Panel header="휠 기본 정보" className="shadow-2">
      <div className="grid">
        <div className="col-12 md:col-4 mb-2">
          <Controller
            control={control}
            name={fieldPath('productName')}
            defaultValue=""
            render={({ field }) => (
              <>
                <Grouped.TitledInputText
                  id={field.name}
                  title="제품명"
                  {...field}
                  readOnly={readOnly}
                />
                {getFormErrorMessage?.(field.name)}
              </>
            )}
          />
        </div>
        <div className="col-12 md:col-4 mb-2">
          <Controller
            control={control}
            name={fieldPath('partNumber')}
            defaultValue=""
            render={({ field }) => (
              <>
                <Grouped.TitledInputText
                  id={field.name}
                  title="품번"
                  {...field}
                  readOnly={readOnly}
                />
                {getFormErrorMessage?.(field.name)}
              </>
            )}
          />
        </div>
        <div className="col-12 md:col-4 mb-2">
          <Controller
            control={control}
            name={fieldPath('size')}
            defaultValue=""
            render={({ field }) => (
              <>
                <Grouped.TitledInputText
                  id={field.name}
                  title="사이즈"
                  {...field}
                  readOnly={readOnly}
                />
                {getFormErrorMessage?.(field.name)}
              </>
            )}
          />
        </div>

        <div className="col-12">
          <div className="overflow-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className={`${thClass} ${categoryColClass}`} style={{ width: '6.5rem' }}>
                    휠 위치
                  </th>
                  {specColumns.map((col) => (
                    <th key={col.name} className={thClass}>
                      {col.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {wheelSpecRows.map((row) => (
                  <tr key={row.prefix}>
                    <th className={`${thClass} bg-gray-100 text-color ${categoryColClass}`}>
                      {row.label}
                    </th>
                    {specColumns.map((col) => (
                      <td key={`${row.prefix}_${col.name}`} className={tdClass}>
                        <Controller
                          control={control}
                          name={fieldPath(`${row.prefix}.${col.name}`)}
                          defaultValue=""
                          render={({ field }) => (
                            <Grouped.InputText
                              id={field.name}
                              {...field}
                              className="w-full"
                              readOnly={readOnly}
                            />
                          )}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default WheelBasicInfoPanel;
